<template>
  <b-container class="px-0 mx-0" fluid="true">
    <b-row no-gutters>
      <b-col>
        <VBox>
          <DataGrid2
              @row-dblclicked="showChangeEventDetails"
              v-model="selectedChangeEvent"
              :selectedIndex.sync="selectedIndex"
              :items="lists"
              :columns="fields"
              :dblClickEnabled="true"
              :headerShowReload="true"
              @reload="refresh"
              @details="showChangeEventDetails"
          >
          </DataGrid2>
        </VBox>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Activity from "@/activity/Activity";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import VBox from "@/components/VBox";
import Rpc from "@/Rpc";
import moment from "moment-timezone";
import ChangeSpec from "@/server/com/silkplm/engine/audit/ChangeSpec";
import FormsAI from "@/components/forms/FormsAI";

moment.suppressDeprecationWarnings = true;

const AuditLogDetails = () => require("@/components/audit-log/AuditLogDetails");

export default {
  name: "AuditLog",
  components: {VBox, DataGrid2},

  async mounted() {
    await this.refresh();
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.entityLabel + $tr('webSocket.history',' history');
    },

    async refresh() {
      this.lists = await Rpc.Audit.listEntityChanges(this.formClass, this.entityInstance.id);
      this.lists.reverse();
      this.setDates();
      this.setChangeTypes();
    },
    async showChangeEventDetails() {
      let label = null;
      let foreignEntityName = null;
      if (this.selectedChangeEvent) {
        if(this.selectedChangeEvent.chgs[0].t === "f_d"){
          label = this.selectedChangeEvent.chgs[0].mFtL;
          let formConfigChangeEventForeignKey = FormsLoader.detectFormConfig(this.selectedChangeEvent.chgs[0].eCls, true);
          foreignEntityName = formConfigChangeEventForeignKey.entityName;

        }
        else if(this.selectedChangeEvent.chgs[0].t === "f_a"){

          label = this.selectedChangeEvent.chgs[0].mFrL;
          let formConfigChangeEventForeignKey = FormsLoader.detectFormConfig(this.selectedChangeEvent.chgs[0].eCls, true);
          foreignEntityName = formConfigChangeEventForeignKey.entityName;
        }
        else{
          label = this.selectedChangeEvent.eL;
        }
        // let formConfigChangeEventForeignKey = FormsLoader.detectFormConfig(this.changeEvent.chgs[0].eCls, true);
        // let entityName = formConfigChangeEventForeignKey.entityName;
        // TODO
        // entityLabel -- > entityForeignLabel
        // entityLabel --> ten z ktorego otwieramy
        await ActivityManager.showActivity(AuditLogDetails, {
          entityInstance: this.entityInstance,
          entityLabel: label,
          foreignEntityName: foreignEntityName,
          changeEvent: this.selectedChangeEvent
        });
      }
    },

    setDates() {
      let userLocale = window.navigator.language;
      for (let i = 0; i < this.lists.length; i++) {
        let ts = moment(this.lists[i].ts);
        this.lists[i].ts = ts.locale(userLocale).format("L") + " " + ts.locale(userLocale).format("LT");
      }
    },

    setChangeTypes() {
      for (let i = 0; i < this.lists.length; i++) {
        if (this.lists[i].chgTp === "D") {
          this.lists[i].chgTp = "Delete";
        } else if (this.lists[i].chgTp === "U") {
          // TODO nie przychodzi
          this.lists[i].chgTp = "Update";
        } else if (this.lists[i].chgTp === "I") {
          this.lists[i].chgTp = "Insert";
        } else if (this.lists[i].chgTp === "F_A" || this.lists[i].chgTp === "F_D" || this.lists[i].chgTp === "F_U") {
          let formConfigChangeEventForeignKey = FormsLoader.detectFormConfig(this.lists[i].chgs[0].eCls, true);
          let entityName = formConfigChangeEventForeignKey.entityName;
          if (this.lists[i].chgTp === "F_A") {
            if(this.lists[i].chgs[0].mFrId){
              let foreignKeyMovedFromLabel= this.lists[i].chgs[0].mFrL;
              this.lists[i].chgTp = entityName + " moved from " + foreignKeyMovedFromLabel;
            }
            else{
              this.lists[i].chgTp = entityName + " added";
            }
          } else if (this.lists[i].chgTp === "F_D") {
            if(this.lists[i].chgs[0].mFtId){
              let foreignKeyMovedToLabel= this.lists[i].chgs[0].mFtL;
              this.lists[i].chgTp = entityName + " moved to " + foreignKeyMovedToLabel;
            }
            else{
              this.lists[i].chgTp = entityName + " deleted";
            }
          } else if (this.lists[i].chgTp === "F_U") {
            this.lists[i].chgTp = entityName + " changed";
          }
        }
      }
    },

  },

  props: {
    entityInstance: {default: null},
    formClass: {type: String, default: ""},
    entityLabel: {type: String, default: ""},
  },


  data: () => ({
    /** @type{CompanyInfo[]} */
    lists: [],
    fields: [
      {name: 'Entity Label', sortable: true, size: 300, prop: 'eL'},
      {name: 'Change Type', sortable: true, size: 300, prop: 'chgTp'},
      {name: 'Date', sortable: true, size: 300, prop: 'ts'},
      {name: 'Entity Id', sortable: true, size: 210, prop: 'eId'},
      {name: 'User', sortable: true, size: 210, prop: 'uNm'},
    ],
    selectedChangeEvent: null,
    selectedChangeEventId: null,
    selectedIndex: null,
    selectedChangeEventIndex: null,
  }),

}
</script>
